<template>
    <Dialog
      :style="{ width: '550px' }"
      :visible="displayAgregarPeriferico"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >
      <template #header>
        <h3>{{ modoEdicion }} periférico</h3>
      </template>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="unidad">Unidad y Subred</label>
          <Dropdown
            id="unidad"
            appendTo="body"
            v-model="periferico.tUnidad"
            :options="lstUnidades"
            optionLabel="UNIDAD_SUBRED"
            placeholder="Selecciona una unidad"
            :filter="true"
            :class="{
              'p-invalid': submitted && !periferico.tUnidad,
            }"
          />
          <small class="p-invalid" v-if="submitted && !periferico.tUnidad"
            >La unidad es requerida.</small
          >
        </div>
        <div class="p-field col">
          <label for="tipoperiferico">Tipo</label>
          <Dropdown
            id="tipoperiferico"
            appendTo="body"
            v-model="periferico.tTipo"
            :options="lstTiposPerifericos"
            optionLabel="Tipo"
            placeholder="Selecciona un tipo o escribe uno nuevo"
            :class="{
              'p-invalid': submitted && !periferico.tTipo,
            }"
          />
          <small class="p-invalid" v-if="submitted && !periferico.tTipo"
            >El tipo es requerido.</small
          >
        </div>
        <div class="p-field col-12">
          <label for="ipperiferico">IP</label>
          <InputText
            autocomplete="off"
            id="ipperiferico"
            v-model.trim="periferico.IP"
            autofocus
          />
        </div>
      </div>


      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="marcaperiferico">Marca</label>
          <InputText
            autocomplete="off"
            id="marcaperiferico"
            v-model.trim="periferico.Marca"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !periferico.Marca }"
          />
          <small class="p-invalid" v-if="submitted && !periferico.Marca"
            >La marca es requerida.</small
          >
        </div>
        <div class="p-field col">
          <label for="modeloperiferico">Modelo</label>
          <InputText
            autocomplete="off"
            id="modeloperiferico"
            v-model.trim="periferico.Modelo"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !periferico.Modelo }"
          />
          <small class="p-invalid" v-if="submitted && !periferico.Modelo"
            >El modelo es requerido.</small
          >
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="serieperiferico">No. serie</label>
          <InputText
            autocomplete="off"
            id="serieperiferico"
            v-model.trim="periferico.Serie"
            required="true"
            autofocus
          />
        </div>
        <div class="p-field col">
          <label for="nni">NNI</label>
          <InputText
            autocomplete="off"
            id="ref"
            v-model.trim="periferico.NNI"
            autofocus
          />
        </div>
        <div class="p-field col-12">
          <label for="mac">MAC</label>
          <InputMask
            autocomplete="off"
            id="ref"
            v-model.trim="periferico.MAC"
            mask="**:**:**:**:**:**"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="obs">Observaciones</label>
          <Textarea
            autocomplete="off"
            id="obs"
            v-model.trim="periferico.Observaciones"
            autofocus
          />
        </div>
      </div>

      <div class="field col-4 md:col-4">
        <label for="fecha_instalacion">Fecha de instalación</label>
        <Calendar
          id="fecha_instalacion"
          v-model="periferico.Fecha_instalacion"
          :value="periferico.Fecha_instalacion"
          dateFormat="mm-dd-yy"
          :class="{ 'p-invalid': submitted && !periferico.Fecha_instalacion }"
        />
        <small
          class="p-invalid"
          v-if="submitted && !periferico.Fecha_instalacion"
          >La fecha de instalación es requerida.</small
        >
      </div>
      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarDialogo"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-text"
          @click="guardarPeriferico"
        />
      </template>
    </Dialog>
</template>
<script>
import SrvrPerifericos from "../service/Perifericos";
import Srvr from "../service/Inventario";
import Utilerias from "../utilidades/Utilerias";
import { mapGetters } from "vuex";

export default{
    props: {
        perifericoFormulario : Object,
        unidadSeleccionada : Object,
        displayComponent: Boolean
    },
    emits: ['onSave','onClose','onDelete'],
    data(){
        return {
            periferico: {},
            lstTiposPerifericos: [
                {
                Tipo: "IMPRESORA",
                },
                {
                Tipo: "MULTIFUNCIONAL",
                },
                {
                Tipo: "MONITOR",
                },
                {
                Tipo: "LECTOR",
                },
                {
                Tipo: "PANTALLA",
                },
                {
                Tipo: "DIADEMA",
                },
                {
                Tipo: "CAMARA WEB",
                },
                {
                Tipo: "ESCANER",
                },
                {
                Tipo: "UPS",
                },
            ],
            lstUnidades: [],
            displayAgregarPeriferico: false,
            modoEdicion: "",
            submitted : false,
        };
    },
    watch: {
        perifericoFormulario(newValue){
        if(newValue && newValue.Id_equipo_periferico){
            this.periferico = { ...newValue };
            this.modoEdicion = "Editar";
            this.periferico.tUnidad = {};
            let unidad = {
                UNIDAD: this.periferico.Unidad,
                SUBRED: this.periferico.Subred,
                UNIDAD_SUBRED:
                this.periferico.Unidad + " (" + this.periferico.Subred + ")",
            };
            this.periferico.tUnidad = unidad;
            this.periferico.Id_usuario_mod =
                this.getUsuarioLogueado.Usuario.Id_usuario;
            this.periferico.tTipo = {};
            this.periferico.tTipo = { Tipo: this.periferico.Tipo };
            this.periferico.Fecha_instalacion = this.getFechaWCFDate(
                this.periferico.Fecha_instalacion,
                null
            );

        }else{
            this.periferico = { ...newValue };
            this.cargaInicial();
            this.submitted = false;
            this.modoEdicion = "Agregar";
            // this.periferico.Id_equipo_computo = objEquipo.Id_equipo_computo;
            this.periferico.tUnidad = {};
            if(this.unidadSeleccionada){
                this.periferico.tUnidad = {...this.unidadSeleccionada};
            }
        }
        },
        displayComponent(newValue){
            this.displayAgregarPeriferico = newValue;
        }
    },
    methods: {
        cancelarDialogo() {
            this.submitted = false;
            this.displayAgregarPeriferico = false;
            this.modoEdicion = "";
            this.periferico = {};
            this.$emit('onClose');
        },
        // agregarPeriferico(objEquipo) {
        //     this.cargaInicial();
        //     this.submitted = false;
        //     this.displayAgregarPeriferico = true;
        //     this.modoEdicion = "Agregar";
        //     this.periferico.Id_equipo_computo = objEquipo.Id_equipo_computo;
        //     this.periferico.tUnidad = {};
        //     Object.assign(this.periferico.tUnidad, this.selectedUnidadFiltro);
        // },
        // editarPeriferico(obj) {
        //     this.periferico = { ...obj };
        //     this.displayAgregarPeriferico = true;
        //     this.modoEdicion = "Editar";
        //     this.periferico.tUnidad = {};
        //     let unidad = {
        //         UNIDAD: this.periferico.Unidad,
        //         SUBRED: this.periferico.Subred,
        //         UNIDAD_SUBRED:
        //         this.periferico.Unidad + " (" + this.periferico.Subred + ")",
        //     };
        //     this.periferico.tUnidad = unidad;
        //     this.periferico.Id_usuario_mod =
        //         this.getUsuarioLogueado.Usuario.Id_usuario;
        //     this.periferico.tTipo = {};
        //     this.periferico.tTipo = { Tipo: this.periferico.Tipo };
        //     this.periferico.Fecha_instalacion = this.getFechaWCFDate(
        //         this.periferico.Fecha_instalacion,
        //         false
        //     );
        //     //this.reiniciaEquipo();
        // },
        guardarPeriferico() {
            var t = this;
            this.submitted = true;
            //t.periferico.Id_equipo_computo = t.idEquiposAbiertos.Id_equipo_computo;
            if (
                !t.periferico ||
                !t.periferico.tUnidad ||
                !t.periferico.tTipo ||
                !t.periferico.Marca ||
                !t.periferico.Modelo ||
                !t.periferico.Id_equipo_computo
            )
                return;


            t.periferico.Unidad = t.periferico.tUnidad.UNIDAD;
            t.periferico.Subred = t.periferico.tUnidad.SUBRED;
            const fechaOriginal = t.periferico.Fecha_instalacion;
            const restoreFechaOriginal = () => {
                t.periferico.Fecha_instalacion = fechaOriginal;
            };

            if (t.periferico.tTipo.Tipo) {
                t.periferico.Tipo = t.periferico.tTipo.Tipo;
            } else {
                t.periferico.Tipo = t.periferico.tTipo;
            }

            if (!t.periferico.NNI) {
                t.periferico.NNI = "";
            }

            if (!t.periferico.MAC) {
                t.periferico.MAC = "";
            }

            if (!t.periferico.Serie) {
                t.periferico.Serie = "";
            }

            if (!t.periferico.Observaciones) {
                t.periferico.Observaciones = "";
            }

            if (!t.periferico.IP) {
                t.periferico.IP = null;
                t.periferico.Subred = null;
            }

            t.periferico.Fecha_instalacion = this.formateaFechaDATE(
                t.periferico.Fecha_instalacion
            );

            t.periferico.Id_usuario_registro =
                t.getUsuarioLogueado.Usuario.Id_usuario;

            if (t.periferico.IP !== null) {
                if (!t.validarEstructuraIP(t.periferico.IP)) {
                t.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "La IP ingresada no tiene una estructura válida.",
                    life: 5000,
                });
                restoreFechaOriginal();
                return;
                }
            }
            var ctlSvr = new SrvrPerifericos();
            t.$confirm.require({
                    message: '¿Está seguro que desea guardar esta información?',
                    header: 'Confirmacion',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        if (t.modoEdicion == "Agregar") {
                            ctlSvr
                            .addPeriferico(t, t.periferico)
                            .then(() => {
                                t.$toast.add({
                                severity: "success",
                                summary: "AVISO",
                                detail: "Periférico agregado correctamente",
                                life: 3000,
                                });
                                // let equipo = t.lstEquipos.find(
                                // (e) => e.Id_equipo_computo == t.periferico.Id_equipo_computo
                                // );
                                // if (equipo) t.cargaPerifericos(equipo);
                                // equipo.num_perifericos++;
                                // t.cancelarDialogo();
                                t.$emit('onSave');
                            })
                            .catch(() => {
                                restoreFechaOriginal();
                            });
                        } else {
                            ctlSvr
                            .updatePeriferico(t, t.periferico)
                            .then(() => {
                                t.$toast.add({
                                severity: "success",
                                summary: "AVISO",
                                detail: "Periférico editado correctamente",
                                life: 3000,
                                });
                                // let equipo = t.lstEquipos.find(
                                // (e) => e.Id_equipo_computo == t.periferico.Id_equipo_computo
                                // );
                                // if (equipo) t.cargaPerifericos(equipo);
                                // t.cancelarDialogo();
                                t.$emit('onSave');
                            })
                            .catch(() => {
                                restoreFechaOriginal();
                            });
                        }
                    },
                    reject: () => {
                    }
            });

        },
        eliminarPeriferico(obj) {
            var t = this;
            t.$confirm.require({
                    message: '¿Está seguro de eliminar este periferico?',
                    header: 'Confirmacion',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        let id_usuario = t.getUsuarioLogueado.Usuario.Id_usuario;
                        var val = obj.Id_equipo_periferico;
                        //this.periferico.Id_equipo_computo = this.idEquiposAbiertos.Id_equipo_computo;
                        var ctlSvr = new SrvrPerifericos();
                        ctlSvr.deletePeriferico(t, val, id_usuario).then(() => {
                        t.$toast.add({
                            severity: "success",
                            summary: "AVISO",
                            detail: "Dispositivo eliminado correctamente",
                            life: 3000,
                        });
                        t.emit('onDelete');
                        // let equipo = t.lstEquipos.find(
                        //     (e) => e.Id_equipo_computo == obj.Id_equipo_computo
                        // );
                        // t.cargaPerifericos(equipo);
                        // if (equipo) {
                        //     equipo.num_perifericos--;
                        // }
                        });
                    },
                    reject: () => {
                    }
            });
        },
        // cargaPerifericos(obj) {
        //     var t = this;
        //     var ctlSvr = new SrvrPerifericos();
        //     t.loadingPerifericos = true;
        //     if (obj.Id_equipo_computo === 0) {
        //         obj.lstPerifericos = [];
        //         t.loadingPerifericos = false;
        //     } else {
        //         ctlSvr.getPerifericosPorEquipo(t, obj.Id_equipo_computo).then((res) => {
        //         t.loadingPerifericos = false;
        //         obj.lstPerifericos = res;
        //         });
        //     }
        // },
        cargaInicial() {
            var t = this;
            var ctlSvr = new Srvr();
            ctlSvr.getUnidades(t).then((res) => {
                t.lstUnidades = res;
            });
        },
        getFechaWCFDate(fecha, hora) {
            var utils = new Utilerias();
            return utils.getFechaWCFDate(fecha, hora);
        },
        formateaFechaDATE(fecha) {
            return "/Date(" + fecha.getTime() + ")/";
        },
        validarEstructuraIP(ip) {
            const ipRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
            return ipRegex.test(ip);
        },
    },
    computed: {
        ...mapGetters(["getUrlServicios", "getUsuarioLogueado"]),
    },
}
</script>